import {
  FETCHING_MONITORS,
  FETCHED_MONITORS,
  FETCHING_MONITORS_ERROR,
  PUBLISH_MONITOR_COUNT
} from '../actions/actionTypes';

const monitorsInitialState = {
  isFetching: false,
  monitorUsers: {
    connectedSponsorUsers: null
  },
  error: null,
  monitorsCount: 0
};

const monitorsReducer = (state = monitorsInitialState, action) => {
  switch (action.type) {
    case FETCHING_MONITORS:
      return Object.assign({}, state, {
        isFetching: true,
        monitorUsers: { connectedSponsorUsers: null },
        monitorsCount: 0
      });
    case FETCHED_MONITORS:
      if (Object.keys(action.payload.data).length === 0) {
        return Object.assign({}, state, {
          isFetching: false,
          error: null,
          monitorUsers: { connectedSponsorUsers: {} }
        });
      } else {
        return Object.assign({}, state, {
          isFetching: false,
          error: null,
          monitorUsers: { connectedSponsorUsers: action.payload.data.connectedSponsorUsers }
        });
      }
    case FETCHING_MONITORS_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        monitorUsers: { connectedSponsorUsers: null },
        error: action.payload,
        monitorsCount: 0
      });
    case PUBLISH_MONITOR_COUNT:
      return Object.assign({}, state, { monitorsCount: action.payload });
    default:
      return state;
  }
};

export default monitorsReducer;
